import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { BaseTemplate } from '../../components/templates';
import withResponseHandling from '../../hoc/withResponseHandling';
import MembrosList from './MembrosList';
import MembroRegras from './MembroRegras';
import MembroAssinaturas from './MembroAssinaturas';

const EntidadeMembros = memo(props => {
  const xDefaultEntidadeStored = useSelector(store => store.entidade.current);
  const [payloadDialog, setPayloadDialog] = useState({});

  const { user, tipo } = payloadDialog;

  // Constantes para os acessos, assinaturas e tipos
  const xRecursosLabels = {
    RLENQ: 'Enquadramento',
    RLVAR: 'Risco',
    RLDUR: 'Duration',
    RLSTT: 'Stress Test',
    RLCNC: 'Conferência Custodiante',
    CFENQ: 'Configuração Enquadramento'
  };

  return (
    <BaseTemplate title="Membros" subtitle={xDefaultEntidadeStored.entidade} maxWidth="lg">
      <MembrosList setPayloadDialog={setPayloadDialog} />
      <MembroRegras
        open={tipo === 'regras'}
        user={user}
        recursosLabels={xRecursosLabels}
        onClose={() => setPayloadDialog({})}
      />
      <MembroAssinaturas
        open={tipo === 'assinaturas'}
        user={user}
        recursosLabels={xRecursosLabels}
        onClose={() => setPayloadDialog({})}
      />
    </BaseTemplate>
  );
});

export default withResponseHandling(EntidadeMembros);
